"use client";

import Link from "next/link";
import { X } from "lucide-react";
import { useUser } from "../hooks/useUser";

type WelcomeModalContentProps = {
  onClose: () => void;
};

export function WelcomeModalContent({ onClose }: WelcomeModalContentProps) {
  const { user, serverEmail } = useUser();
  const email = user?.email ?? serverEmail ?? null;

  return (
    <>
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 p-1.5 rounded-lg text-[#6b7785] hover:text-[#c7d5e0] hover:bg-[#1e3248]/50 transition-colors"
        aria-label="Close"
      >
        <X className="w-5 h-5" />
      </button>

      <div className="mb-6">
        <h2 className="text-xl font-bold text-white">Welcome!</h2>
        <p className="text-sm text-[#6b7785] mt-1">
          Email confirmed{email ? `: ${email}` : ""}. Your session is ready.
        </p>
      </div>

      <div className="flex flex-wrap gap-3 pt-2">
        <Link
          href="/"
          onClick={onClose}
          className="inline-flex items-center justify-center rounded-lg bg-[#66c0f4] text-[#0b1118] font-semibold px-4 py-2 hover:brightness-105 active:brightness-95 transition"
        >
          Go to Home
        </Link>
        <Link
          href="/all-games"
          onClick={onClose}
          className="inline-flex items-center justify-center rounded-lg border border-[#2a475e] bg-[#16202d] text-[#c7d5e0] font-semibold px-4 py-2 hover:bg-[#1f2e3f] hover:text-white transition"
        >
          Browse games
        </Link>
      </div>
    </>
  );
}
